class CircleProgress{

    constructor(opts){
        this.container = null;
        this.size = 112;
        this.stroke = 4;
        this.strokeColor = '#1aa7ec';
        this.showEmptyStroke = false;
        this.dasharray = null;
        this.positionX = null;
        this.positionY = null;

        this.setRadius(53);

        this.className = null;

        if(opts){
            this.className = opts.className ?? null;
            if(opts.stroke) this.stroke = opts.stroke;
            if(opts.size) this.setSize(opts.size);
            if(opts.radius) this.setRadius(opts.radius);
            if(opts.strokeColor) this.setStrokeColor(opts.strokeColor);
            if(opts.showEmptyStroke !== undefined) this.showEmptyStroke = opts.showEmptyStroke;
        }

    }

    setRadius(radius){
        this.radius = radius;
        this.dasharray = Math.ceil(2 * 3.14 * this.radius);
    }

    setSize(size){
        this.size = size;
        this.positionX = this.size / 2 * -1;
        this.positionY = this.size / 2;
    }

    setStroke(stroke){
        this.stroke = stroke;
    }

    setStrokeColor(color){
        this.strokeColor = color;
        let circle = this.container.querySelector('.circle');
        if(circle){
            circle.setAttribute('stroke', color);
        }
    }

    render(){

        this.container = document.createElement('div');
        this.container.classList.add('uploadProgress');
        this.container.classList.add('circleProgress');
        this.container.style = 'width:' + this.size + 'px; height:' + this.size + 'px';

        if(this.className){
            this.container.classList.add(this.className);
        }

        let emptyStroke = '';
        if(this.showEmptyStroke === true){
            emptyStroke = '<circle stroke-linecap="round" cx="'+this.positionX+'" cy="'+this.positionY+'" r="'+this.radius+'" stroke="#27303a" stroke-width="'+this.stroke+'" fill="none" stroke-dasharray="'+this.dasharray+'" stroke-dashoffset="'+this.dasharray+'" transform="rotate(-90)" class="emptyStroke" style="stroke-dashoffset: 0;"></circle>'
        }

        this.container.innerHTML = '<svg style="width:'+this.size+'px;height:'+this.size+'px" width="'+this.size+'" height="'+this.size+'" viewBox="0 0 '+this.size+' '+this.size+'">' + emptyStroke +
            '<circle stroke-linecap="round" cx="'+this.positionX+'" cy="'+this.positionY+'" r="'+this.radius+'" stroke="' + this.strokeColor + '" stroke-width="'+this.stroke+'" fill="none" stroke-dasharray="'+this.dasharray+'" stroke-dashoffset="'+this.dasharray+'" transform="rotate(-90)" class="circle"></circle>' +
        '</svg>';
        return this.container;

    }

    preview(url){
        let preview = document.createElement('div');
        preview.classList.add('preview');
        preview.style.width = this.size+'px';
        preview.style.height = this.size+'px';
        preview.style.border = this.stroke+'px solid #e9e9e9';
        preview.style.padding = this.stroke+'px';

        preview.innerHTML = '<img src="'+url+'" alt>';
        this.container.appendChild(preview);
    }

    videoPreview(url){
        let preview = document.createElement('div');
        preview.classList.add('videoPreview');
        preview.style.width = this.size+'px';
        preview.style.height = this.size+'px';
        preview.style.border = '0';
        preview.style.padding = '0';

        preview.innerHTML = '<video src="'+url+'" class="cover"></video>';
        this.container.appendChild(preview);
    }

    update(percent){
        let self = this;
        const circle = this.container.querySelector('.circle');
        circle.style.strokeDashoffset = (Math.round((this.dasharray - (this.dasharray / 100 * percent)))).toString();
        if(percent === 100){
            setTimeout(function(){
                circle.style.strokeDashoffset = this.dasharray;
                self.removeProgressLine();
            }, 1000);
        }
    }

    removeProgressLine(){
        this.container.querySelector('svg').remove();
        this.container.innerHTML = '<i class="icon-play"></i>';
    }
}

export default CircleProgress;